import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { IWidget } from 'common/schema/widget/Widget';
import { yup } from 'common/validation/initYup';
import { fromPairs, isEmpty, sortBy } from 'lodash';

/**
 * Validatore dedicato per gli N metadati che compongono un Widget di
 * selezione a cascata
 */
// TODO Gestire validatore "globale" per tutti i campi per assicurarsi che la combinazione sia valida
export function createWidgetInputCascadeSelectValidator(widget: IWidget) {
  const input = widget.input!;
  const metadatas = input.metadata;

  const cascade = widget.input?.extra?.cascade;
  const cascadeFields = sortBy(cascade!.fields ?? [], 'order');
  const firstField = cascadeFields[0];

  return fromPairs(
    metadatas.map(metadata => {
      let schema = yup.string().label(metadata.code ?? metadata.name);

      if (input.required) {
        schema = schema.requiredMetadata(metadata, input);
      }

      // Dobbiamo comunque gestire la situazione in cui, se si compila un campo
      // è comunque necessario compilarli tutti
      if (metadata.id !== firstField?.metadataId) {
        schema = schema.when(
          [firstField?.metadataId],
          (firstFieldValue: any, schema: yup.StringSchema<any>) => {
            return isEmpty(firstFieldValue) ? schema : schema.required();
          }
        );
      }
      return [metadata.id, schema];
    })
  );
}
